import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import ACHUserDetailsCollectableDataComponentiOS from './achUserDetailsCollectableData.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Item title='updateCollectedData(collectableData: ACHUserDetailsCollectableData)' mdxType="Item">
      <p>{`Update component with collected data by passing an enum representing collectable data. This method can be called at any point, even if you have only partially collected data.
To validate the partially collected data, you can refer to the `}<a href={`#supported-types.StripeAchUserDetailsComponent-api.validationDelegate`}>{`validationDelegate`}</a>{` and receive the validation status when it's updated.`}</p>
      <p>{`In case of ACH, the Data will be of type `}<code>{`ACHUserDetailsCollectableData`}</code>{`.`}</p>
      <ACHUserDetailsCollectableDataComponentiOS mdxType="ACHUserDetailsCollectableDataComponentiOS" />
      <p>{`Example:`}</p>
      <pre><code parentName="pre" {...{
          "className": "language-swift"
        }}>{`func updateCollectedData(collectableData: ACHUserDetailsCollectableData)
`}</code></pre>
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      